import React from "react";

export interface AmountRenderProps {
    amount: number | string;
    currency?: string;
    percentage?: number;
}

export function AmountRender(props: AmountRenderProps) {
    const amount = Number(props.amount);
    const value = props.percentage ? amount * props.percentage : amount;
    return <>{value.toFixed(2)} {props.currency}</>
}
